"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/typeof"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["className", "as", "children", "xs", "sm", "md", "lg"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var Col = function Col(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$as = _ref.as,
    as = _ref$as === void 0 ? 'div' : _ref$as,
    children = _ref.children,
    xs = _ref.xs,
    sm = _ref.sm,
    md = _ref.md,
    lg = _ref.lg,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var As = as;
  var getClassNames = function getClassNames(breakpoint, value) {
    var classNames = '';
    if (value && (0, _typeof2["default"])(value) === 'object') {
      if (value.order) {
        classNames += " ORDER-".concat(breakpoint === 'xs' ? '' : "".concat(breakpoint.toUpperCase(), "-")).concat(value.order.toString().toUpperCase());
      }
      if (value.offset) {
        classNames += " OFFSET-".concat(breakpoint === 'xs' ? '' : "".concat(breakpoint.toUpperCase(), "-")).concat(value.offset);
      }
      if (value.span) {
        classNames += " COL-".concat(breakpoint === 'xs' ? '' : "".concat(breakpoint.toUpperCase(), "-")).concat(value.span);
      }
    } else if (value && value === true) {
      classNames += breakpoint === 'xs' ? '' : " COL-".concat(breakpoint.toUpperCase());
    } else if (value && value.toString().length > 0) {
      classNames += " COL-".concat(breakpoint === 'xs' ? '' : "".concat(breakpoint.toUpperCase(), "-")).concat(value.toString().toUpperCase());
    }
    return classNames;
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(As, _objectSpread(_objectSpread({
    className: "Col ".concat(className, " ").concat(getClassNames('xs', xs), " ").concat(getClassNames('sm', sm), " ").concat(getClassNames('md', md), " ").concat(getClassNames('lg', lg))
  }, rest), {}, {
    children: children
  }));
};
var _default = Col;
exports["default"] = _default;